module.exports = __webpack_public_path__ + "static/media/Parody - Instrumental Version.c2642bb3.jpg";